
import { inAppRedirect, appURLs } from '~/utils/route-redirects';

export default {
  name: 'NotificationLeagueRankChange',
  props: {
    notif: {
      required: true,
      type: Object,
    },
  },
  methods: {
    goToLeague() {
      inAppRedirect(appURLs.leagueById(this.notif.leagueId));
    },
  },
};
